import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { forwardRef, isValidElement } from 'react';
import { Stack } from '../Layout';
import { theme } from '../theme';
import { Tooltip } from '../Tooltip';
import { useHint } from './Hint';
import { BaseText } from './styled';
export const Text = /*#__PURE__*/ forwardRef(({ level, hint, tooltip, tone, weight, elementType, children, ...rest }, ref)=>{
    const _hint = useHint({
        hint,
        level,
        tone
    });
    let childrenUI = children;
    if (_hint) {
        childrenUI = /*#__PURE__*/ _jsxs(Stack, {
            gap: theme.spaces.x4,
            direction: "horizontal",
            alignY: "center",
            children: [
                children,
                /*#__PURE__*/ _jsx(_Fragment, {
                    children: _hint
                })
            ]
        });
    }
    if (tooltip) {
        const tooltipProps = /*#__PURE__*/ isValidElement(tooltip) || typeof tooltip === 'string' ? {
            title: tooltip,
            placement: 'top'
        } : tooltip;
        childrenUI = /*#__PURE__*/ _jsx(Tooltip, {
            ...tooltipProps,
            children: /*#__PURE__*/ _jsx("span", {
                children: childrenUI
            })
        });
    }
    return /*#__PURE__*/ _jsx(BaseText, {
        ...rest,
        tone: tone,
        weight: weight,
        as: elementType,
        level: level,
        ref: ref,
        children: childrenUI
    });
});
